import { type SxProps, type Theme } from '@mui/material'

export const tableStyles = {
  container: {
    overflowX: 'auto',
    border: '1px solid var(--blue-300)',
    borderRadius: '8px',
    backgroundColor: 'var(--white)'
  } satisfies SxProps<Theme>,
  headCell: {
    fontFamily: 'Open Sans',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 700,
    textTransform: 'uppercase',
    color: 'var(--grey-700)',
    padding: '13px 16px',
    borderBottom: '1px solid var(--grey-200)',
    whiteSpace: 'nowrap'
  } satisfies SxProps<Theme>,
  sortableHeadCell: {
    cursor: 'pointer',
    userSelect: 'none'
  } satisfies SxProps<Theme>,
  headLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    verticalAlign: 'middle'
  } satisfies SxProps<Theme>,
  bodyCell: {
    fontFamily: 'Open Sans',
    fontSize: '14px',
    lineHeight: 1.4,
    color: 'var(--grey-700)',
    padding: '13px 16px',
    borderBottom: '1px solid var(--grey-200)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  } satisfies SxProps<Theme>,
  row: {
    '&:last-child td': { borderBottom: 0 }
  } satisfies SxProps<Theme>
}
